export enum ParticipantTitle {
  Mr = 'Mr',
  Ms = 'Ms',
  KidMale = 'KidMale',
  KidFemale = 'KidFemale',
  BabyMale = 'BabyMale',
  BabyFemale = 'BabyFemale',
}
